<script>
	const moment = require('moment');

	module.exports = {
		components: {
			'book-of-knowledge-entry': require('components/book-of-knowledge-entry.vue').default,
			'article-image': require('components/article-image.vue').default
		},
		props: {
			assignment: {
				default: null
			},
			inlineEdit: {
				default: false
			},
			editable: {
				default: false
			},
			getHeaderLink: {
				default: null,
				type: Function
			},
			onHeaderClick: {
				default: null,
				type: Function
			},
			onArticleClick: {
				default: null,
				type: Function
			},
			onStudentClick: {
				default: null,
				type: Function
			},
			onEditEntry: {
				default: null,
				type: Function
			}
		},
		computed: {
			workspaces() {
				let assignment = this.assignment;
				let spaces = null;
				if (assignment && assignment.workspaces) {
					spaces = assignment.workspaces.filter(ws => {
						return typeof ws.b !== 'undefined' || ws.s === 's';
					});
				}
				return spaces;
			},
			dateRange() {
				let assignment = this.assignment;
				let format = 'MMM D';
				let date = null;

				if (assignment && assignment.d && assignment.ed) {
					let startDate = moment(assignment.d * 1000);
					let endDate = moment(assignment.ed * 1000);
					date = startDate.format(format) + ' - ' + endDate.format(format) + ', ' + endDate.format('Y');
				}

				return date;
			},
			entryCount() {
				let workspaces = this.workspaces;
				let entries = 'entries';

				if (workspaces && workspaces.length === 1) {
					entries = 'entry';
				}
				return workspaces ? '(' + workspaces.length + ' ' + entries + ')' : '';
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';

	.bok-assignment {
		border-top: 1px solid $c-grey;
		padding: 1rem 0;

		.bok-assignment-header {
			display: flex;
			margin-bottom: 1rem;
			cursor: auto;

			.article-image {
				margin-right: 1rem;

				.article-featured-image-container {
					height: 3rem;
					width: 3rem;
				}
			}

			.assignment-meta {
				flex: 1;
				display: flex;
				flex-direction: column;
				justify-content: center;

				.product-title {
					margin-bottom: 0;
					margin-top: 0;
					color: $c-slate-dark;
				}

				.assignment-date {
					color: $c-slate-muted;
					font-weight: 500;
				}
			}

			&.header-link {
				cursor: pointer;

				.assignment-meta .product-title {
					color: $c-blue;
				}

				&:hover .assignment-meta .product-title {
					color: $c-slate-dark;
				}
			}
		}

		.card-container {
			> .bok-entry {
				display: inline-block;
				margin-bottom: 1rem;
			}
		}
	}

	@media only screen and (min-width: $bp-width-med) {
		.bok-assignment .card-container > .bok-entry {
			max-width: 20rem;
			margin-right: 1rem;
		}
	}

	@media print {
		.bok-assignment a.bok-assignment-header {
			display: flex !important;
		}
	}
</style>
<template>
	<div class="bok-assignment">
		<a
			v-if="assignment && assignment.pmd"
			class="bok-assignment-header"
			:class="{
				'header-link': getHeaderLink || onHeaderClick
			}"
			:href="getHeaderLink && getHeaderLink(assignment)"
			@click="onHeaderClick && onHeaderClick(assignment)">
			<article-image
				class="print-hidden"
				:image-url="assignment.pmd.img"
				:alt-text="assignment.pmd.img_alt || assignment.pmd.imgAlt">
			</article-image>
			<div class="assignment-meta">
				<h3 class="product-title">{{ assignment.pmd.title }}</h3>
				<div class="assignment-date">
					{{ dateRange }}
					<span
						v-if="assignment.assigned"
						class="entry-count"
						>{{ entryCount }}</span
					>
				</div>
			</div>
		</a>
		<div v-if="!assignment.assigned">
			<em>The Book of Knowledge was not assigned.</em>
		</div>
		<slot name="entry-container">
			<div
				v-if="assignment.assigned && workspaces"
				class="card-container">
				<book-of-knowledge-entry
					v-for="entry in workspaces"
					:key="entry.uid"
					:entry="entry"
					:article="assignment.pmd.articles && assignment.pmd.allArticles[pid]"
					:on-article-click="onArticleClick"
					:on-student-click="onStudentClick"
					:editable="editable"
					:inline-edit="inlineEdit"
					:on-edit="onEditEntry">
					<template slot="actions">
						<slot name="actions"></slot>
					</template>
				</book-of-knowledge-entry>
			</div>
		</slot>
	</div>
</template>
